import { useMutation } from "@tanstack/react-query";
import { apiClient } from "@/lib/apiClient";
import { apiPath } from "@/lib/apiPath";

/**
 * Payload for submitting a staff review.
 * Flow 1 (Logged-in): client_id is present, email auto-pulled from DB
 * Flow 2 (Guest): client_id absent, client_email optional
 */
export interface ReviewPayload {
    company_id: number;
    staff_id: number;
    review: string;
    rating: number; // 1-5
    client_name: string;
    client_phone: string;
    client_id?: number;      // Logged-in flow only
    client_email?: string;   // Guest flow only (optional)
}

export interface ReviewResponse {
    id: number;
    success: boolean;
}

/**
 * Hook to submit a review for a staff member.
 * Endpoint: POST /api/v1/public/reviews
 */
export function useSubmitReview() {
    return useMutation({
        mutationKey: ["reviews", "submit"],
        mutationFn: async (payload: ReviewPayload): Promise<ReviewResponse> => {
            const { data } = await apiClient.post(apiPath("/public/reviews"), payload);
            return data;
        },
    });
}
